// extracted by mini-css-extract-plugin
export default {"cell":"Cell_cell__+sgmf","editIcon":"Cell_editIcon__ddbQc","placeholderText":"Cell_placeholderText__KQ4KK","imageWrapper":"Cell_imageWrapper__lgxYp","image":"Cell_image__dNURd"};